/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Permission } from './Permission';
import {
    PermissionFromJSON,
    PermissionFromJSONTyped,
    PermissionToJSON,
    PermissionToJSONTyped,
} from './Permission';

/**
 * Permission
 * @export
 * @interface UsersPermissions
 */
export interface UsersPermissions {
    /**
     * 
     * @type {string}
     * @memberof UsersPermissions
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersPermissions
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersPermissions
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersPermissions
     */
    title?: string;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof UsersPermissions
     */
    permissions?: Array<Permission>;
}

/**
 * Check if a given object implements the UsersPermissions interface.
 */
export function instanceOfUsersPermissions(value: object): value is UsersPermissions {
    return true;
}

export function UsersPermissionsFromJSON(json: any): UsersPermissions {
    return UsersPermissionsFromJSONTyped(json, false);
}

export function UsersPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersPermissions {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'title': json['title'] == null ? undefined : json['title'],
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(PermissionFromJSON)),
    };
}

export function UsersPermissionsToJSON(json: any): UsersPermissions {
    return UsersPermissionsToJSONTyped(json, false);
}

export function UsersPermissionsToJSONTyped(value?: UsersPermissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'title': value['title'],
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(PermissionToJSON)),
    };
}

